<template>
	<div class="qualificationQuery-home">
		<!-- 热门查询区域--start -->
		<h3 class="hot-title">查询服务</h3>
		<div class="hot-query-container">
			<div class="hot-query-content">
				<!-- 查询类型切换--start -->
				<div class="query-tabs">
					<span class="tab-item active">查企业</span>
					<span class="tab-item">查人员</span>
					<span class="tab-item">查项目</span>
				</div>
				<!-- 查询类型切换--end -->

				<!-- 搜索框--start -->
				<div class="search-box">
					<div class="input-wrapper">
						<el-input placeholder="请输入查询名称" size="large">
							<template #append>
								<el-button type="primary" size="large">查询</el-button>
							</template>
						</el-input>
						<el-button class="advanced-search" size="large">高级查询</el-button>
					</div>
				</div>
				<!-- 搜索框--end -->

				<!-- 热门查询项--start -->
				<!-- <div class="hot-query-list">
					<h3 class="list-title">热门查询</h3>
					<div class="query-items">
						<div class="query-item">
							<div class="icon icon-czz"></div>
							<div class="item-content">
								<h4>查资质</h4>
								<p>查询资质，降低废证风险</p>
							</div>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="query-item">
							<div class="icon icon-cfx"></div>
							<div class="item-content">
								<h4>查风险</h4>
								<p>查询资质，降低废证风险</p>
							</div>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="query-item">
							<div class="icon icon-cyj"></div>
							<div class="item-content">
								<h4>查业绩</h4>
								<p>查询资质，降低废证风险</p>
							</div>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="query-item">
							<div class="icon icon-hyxy"></div>
							<div class="item-content">
								<h4>查行业信用</h4>
								<p>查询资质，降低废证风险</p>
							</div>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="query-item">
							<div class="icon icon-cll"></div>
							<div class="item-content">
								<h4>查履历</h4>
								<p>查询资质，降低废证风险</p>
							</div>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div class="query-item">
							<div class="icon icon-zzsy"></div>
							<div class="item-content">
								<h4>资质溯源</h4>
								<p>查询资质，降低废证风险</p>
							</div>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
				</div> -->
				<!-- 热门查询项--end -->
			</div>
		</div>
		<!-- 热门查询区域--end -->
		<!-- VIP广告--start -->
		<div class="poster-container">
			<img src="@/assets/index/poster-vip1.png" alt="VIP限时专享，资质办理加速跑" />
		</div>
		<!-- VIP广告--end -->

		<!-- 查询板块--start -->
		<div class="search-container">
			<div class="search-content">
				<div class="tab-container">
					<!-- tab切换区域--start -->
					<div class="cjt-tabs">
						<div class="cjt-tabs__header">
							<div class="cjt-tabs__nav-wrap">
								<div
									v-for="(tab, index) in maintenanceTabs"
									:key="index"
									class="cjt-tabs__item"
									:class="{ active: activeTabIndex === index }"
									@click="changeMaintenanceTab(index)"
								>
									<span class="cjt-tabs__item-text">{{ tab.name }}</span>
								</div>

								<!-- <div class="cjt-tabs-more">
									<router-link to="#">
										更多
										<i class="el-icon-arrow-right"></i>
									</router-link>
								</div> -->
							</div>
						</div>
						<div class="cjt-tabs__container">
							<!-- 内容区域 -->
							<transition name="fade-transform" mode="out-in">
								<div :key="activeTabIndex" class="cjt-tabs__content">
									<!-- 临期提醒内容 -->
									<div v-if="activeTabIndex === 0" class="maintenance-list">
										<!-- 列表项 -->
										<div v-for="(item, index) in checkTheCompanyList" :key="index" class="notification-item">
											<div class="certificate-info">
												<div class="certificate-name">
													<div>
														{{ item.name }}
														<span>XXXXXXXXXXXX建筑公司</span>
													</div>
												</div>
												<div class="certificate-detail">
													<div class="detail-item">
														<label>注册类别：</label>
														<span class="detail-content">
															{{ item.name }}
														</span>
													</div>
													<div class="detail-item">
														<label>证书编号：</label>
														<span class="detail-content">{{ item.num }}</span>
													</div>
													<div class="detail-item">
														<label>注册时间：</label>
														<span class="detail-content">{{ item.sxTime }}</span>
													</div>
												</div>
												<div class="certificate-detail">
													<div class="detail-item">
														<label>注册专业：</label>
														<span class="detail-content">
															{{ item.zy }}
														</span>
													</div>
													<div class="detail-item">
														<label>注册号（执业印章号）：</label>
														<span class="detail-content">{{ item.zch }}</span>
													</div>
													<div class="detail-item">
														<label>有效时间：</label>
														<span class="detail-content">{{ item.yxTime }}</span>
													</div>
												</div>
											</div>
											<div class="certificate-status">
												<span class="collect">
													<svg-icon v-if="item.isCollect" icon-class="collect" class="icon" />
													<svg-icon v-else icon-class="collect" class="icon" />
													查看
												</span>
												<span class="collect">
													<svg-icon v-if="item.isCollect" icon-class="collect" class="icon" />
													<svg-icon v-else icon-class="collect" class="icon" />
													已收藏
												</span>
												<span class="subscriber">
													<svg-icon v-if="item.isSubscriber" icon-class="subscriber" class="icon" />
													<svg-icon v-else icon-class="subscriber" class="icon" />
													已监控
												</span>
											</div>
										</div>
									</div>

									<!-- 其他Tab内容 -->
									<div v-if="activeTabIndex === 1" class="maintenance-list">
										<div v-for="(item, index) in checkPersonnelList" :key="index" class="notification-item">
											<div class="certificate-info">
												<div class="certificate-name">
													<div>
														{{ item.name }}
														<span>XXXXXXXXXXXX建筑公司</span>
													</div>
												</div>
												<div class="certificate-detail">
													<div class="detail-item">
														<label>注册类别：</label>
														<span class="detail-content">
															{{ item.name }}
														</span>
													</div>
													<div class="detail-item">
														<label>证书编号：</label>
														<span class="detail-content">{{ item.num }}</span>
													</div>
													<div class="detail-item">
														<label>注册时间：</label>
														<span class="detail-content">{{ item.sxTime }}</span>
													</div>
												</div>
												<div class="certificate-detail">
													<div class="detail-item">
														<label>注册专业：</label>
														<span class="detail-content">
															{{ item.zy }}
														</span>
													</div>
													<div class="detail-item">
														<label>注册号（执业印章号）：</label>
														<span class="detail-content">{{ item.zch }}</span>
													</div>
													<div class="detail-item">
														<label>有效时间：</label>
														<span class="detail-content">{{ item.yxTime }}</span>
													</div>
												</div>
											</div>
											<div class="certificate-status">
												<span class="collect">
													<svg-icon v-if="item.isCollect" icon-class="collect" class="icon" />
													<svg-icon v-else icon-class="collect" class="icon" />
													查看
												</span>
												<span class="collect">
													<svg-icon v-if="item.isCollect" icon-class="collect" class="icon" />
													<svg-icon v-else icon-class="collect" class="icon" />
													已收藏
												</span>
												<span class="subscriber">
													<svg-icon v-if="item.isSubscriber" icon-class="subscriber" class="icon" />
													<svg-icon v-else icon-class="subscriber" class="icon" />
													已监控
												</span>
											</div>
										</div>

										<!-- <div class="empty-content">
											<i class="el-icon-document"></i>
											<p>暂无数据</p>
										</div> -->
									</div>

									<div v-if="activeTabIndex === 2" class="maintenance-list">
										<div v-for="(item, index) in checkTheProject" :key="index" class="notification-item">
											<div class="certificate-info">
												<div class="certificate-name">
													<div>
														{{ item.name }}
														<span>XXXXXXXXXXXX建筑公司</span>
													</div>
												</div>
												<div class="certificate-detail">
													<div class="detail-item">
														<label>注册类别：</label>
														<span class="detail-content">
															{{ item.name }}
														</span>
													</div>
													<div class="detail-item">
														<label>证书编号：</label>
														<span class="detail-content">{{ item.num }}</span>
													</div>
													<div class="detail-item">
														<label>注册时间：</label>
														<span class="detail-content">{{ item.sxTime }}</span>
													</div>
												</div>
												<div class="certificate-detail">
													<div class="detail-item">
														<label>注册专业：</label>
														<span class="detail-content">
															{{ item.zy }}
														</span>
													</div>
													<div class="detail-item">
														<label>注册号（执业印章号）：</label>
														<span class="detail-content">{{ item.zch }}</span>
													</div>
													<div class="detail-item">
														<label>有效时间：</label>
														<span class="detail-content">{{ item.yxTime }}</span>
													</div>
												</div>
											</div>
											<div class="certificate-status">
												<span class="collect">
													<svg-icon v-if="item.isCollect" icon-class="collect" class="icon" />
													<svg-icon v-else icon-class="collect" class="icon" />
													查看
												</span>
												<span class="collect">
													<svg-icon v-if="item.isCollect" icon-class="collect" class="icon" />
													<svg-icon v-else icon-class="collect" class="icon" />
													已收藏
												</span>
												<span class="subscriber">
													<svg-icon v-if="item.isSubscriber" icon-class="subscriber" class="icon" />
													<svg-icon v-else icon-class="subscriber" class="icon" />
													已监控
												</span>
											</div>
										</div>
										<!-- <div class="empty-content">
											<i class="el-icon-document"></i>
											<p>暂无数据</p>
										</div> -->
									</div>
								</div>
							</transition>
						</div>
					</div>
					<!-- tab切换区域--end -->
				</div>
			</div>
		</div>
		<!-- 查询板块--end -->
	</div>
</template>

<script>
	export default {
		name: 'SearchIndex',
		components: {},
		props: {},
		data() {
			return {
				// 资质维护Tab数据
				activeTabIndex: 0,
				maintenanceTabs: [{ name: '企业' }, { name: '人员' }, { name: '项目' }],

				// 查企业
				checkTheCompanyList: [
					{
						name: '注册土木工程',
						zy: '道路工程',
						zch: '4200049-AD001',
						num: 'AD244200014',
						sxTime: '2020-12-27',
						yxTime: '2024-12-27'
					},
					{
						name: '注册土木工程',
						zy: '道路工程',
						zch: '4200049-AD001',
						num: 'AD244200014',
						sxTime: '2020-12-27',
						yxTime: '2024-12-27'
					},
					{
						name: '注册土木工程',
						zy: '道路工程',
						zch: '4200049-AD001',
						num: 'AD244200014',
						sxTime: '2020-12-27',
						yxTime: '2024-12-27'
					},
					{
						name: '注册土木工程',
						zy: '道路工程',
						zch: '4200049-AD001',
						num: 'AD244200014',
						sxTime: '2020-12-27',
						yxTime: '2024-12-27'
					}
				],

				// 查人员
				checkPersonnelList: [
					{
						name: '建筑业企业资质证书',
						qualificationType: '建筑工程施工总承包贰级；公路工程施工总承包贰级',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程设计企业资质证书',
						qualificationType: '化工石化医药行业（化工工程）专业乙级；电力行业（火力发电（含核电站常规岛设计））专业乙级',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程勘察企业资质证书',
						qualificationType: '工程勘察专业类岩土工程（勘察）乙级；工程勘察专业类岩土工程（设计）乙级',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程质量检测机构资质证书',
						qualificationType: '建筑材料及构配件；主体结构及装饰装修；钢结构',
						warningTime: '20**-**-**'
					}
				],

				// 查项目
				checkTheProject: [
					{
						name: '建筑业企业资质证书',
						qualificationType: '建筑工程施工总承包贰级；公路工程施工总承包贰级',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程设计企业资质证书',
						qualificationType: '化工石化医药行业（化工工程）专业乙级；电力行业（火力发电（含核电站常规岛设计））专业乙级',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程勘察企业资质证书',
						qualificationType: '工程勘察专业类岩土工程（勘察）乙级；工程勘察专业类岩土工程（设计）乙级',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程质量检测机构资质证书',
						qualificationType: '建筑材料及构配件；主体结构及装饰装修；钢结构',
						warningTime: '20**-**-**'
					}
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			// 切换Tab
			changeMaintenanceTab(index) {
				this.activeTabIndex = index
			}
		}
	}
</script>

<style lang="scss" scoped>
	.qualificationQuery-home {
		/* 热门查询 */
		.hot-title {
			font-size: 26px;
			color: #333;
			line-height: 85px;
			text-align: center;
		}
		/* 广告位 */
		.poster-container {
			margin: 23px 0;

			img {
				width: 100%;
				margin: 0 auto;
			}
		}
		// 资质维护
		.search-container {
			background-color: #f5f9fb;
			padding: 20px 0;

			.search-content {
				width: $main-page-width;
				margin: 0 auto;
				.cjt-tabs__item {
					width: 83px;
					text-align: center;
					.cjt-tabs__item-text {
						width: 100%;
					}
				}

				.tab-container {
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 2px 7px 21px 0px rgba(57, 127, 212, 0.17);
					border-radius: 6px;
					.certificate-info {
						flex: 0 0 834px;
						.certificate-name {
							span {
								margin-left: 10px;
							}
						}
						.detail-item {
							label {
								flex: none;
							}
							.detail-content {
								padding-right: 0px;
							}
						}

						.detail-item:nth-child(1) {
							flex: 0 0 269px;
						}
						.detail-item:nth-child(2) {
							flex: 0 0 381px;
						}
					}
					.certificate-status {
						flex-direction: row;
						margin-left: 120px;
						span {
							width: 100px;
							height: 36px;
							background-color: #ffffff;
							border-radius: 18px;
							border: solid 1px #236fca;
							text-align: center;
							color: #236fca;
							font-size: 16px;
							margin-left: 10px;
						}
					}
				}
			}
		}
	}
</style>
